import React from 'react';
import styles from './Overlay.module.css'; // Crie um arquivo CSS separado para os estilos do Overlay

const Overlay = ({ mensagem, isErro, showOverlay }) => {
    if (!showOverlay) return null; // Se não for para mostrar, retorna nulo.

    return (
        <div className={styles.overlay}>
            <p className={isErro ? styles.mensagemErro : styles.mensagem}>
                {mensagem}
            </p>
        </div>
    );
};

export default Overlay;
